import { StandardEvents } from '@shopify/events';
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (Number.isFinite(count)) document.dispatchEvent(new CustomEvent('ox:cart-updated', { detail: { item_count: count } }));
    const notice = document.querySelector('[data-ox-cart-feedback]');
    if (notice && detail?.source === 'product-form-component' && detail.didError === false) notice.hidden = false;
  }).catch((error) => {
    if (error?.name !== 'AbortError') console.warn('[ox-cart-feedback] Cart update failed');
  });
});
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[data-ox-cart-feedback-close]')) {
    const notice = document.querySelector('[data-ox-cart-feedback]');
    if (notice) notice.hidden = true;
  }
});
